import { createSelector } from '@ngrx/store';

import { manageSupplierFeature } from './manage-supplier.reducer';

export const {
  selectManageSupplierState,
  selectSurvey,
  selectAllocations,
  selectFeasibilitySuppliers,
  selectBlends,
  selectGroupTemplates,
  selectDefaultAllocations,
  selectRateCards,
  selectSuppliersMetaData,
  selectRequested,
  selectLoading,
  selectLoadError,
  selectAllocationsUpdateStatus,
  selectBlendSaving,
  selectSavedBlendId,
} = manageSupplierFeature;

export const selectAllocationsUpdating = createSelector(
  selectAllocationsUpdateStatus,
  (status) => status === 'saving',
);

export const selectSuppliersMetaDataBlendId = createSelector(
  selectSuppliersMetaData,
  (metaData) => metaData.blendId,
);
